var r="#292929";export{r as DEFAULT_COLOR};
//# sourceMappingURL=icons.constant.js.map
